import { Loader } from "@obs/base";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { normalizeLocale } from "../intl/normalizeLocale";
import { tripTrackingSearchSchema } from "./$scheduledDate/$serviceName";

const Index = () => {
	return <Loader.State />;
};

const validateSearch = tripTrackingSearchSchema.extend({
	s: z
		.union([z.string(), z.number()])
		.transform((val) => String(val))
		.optional(),
});

export const Route = createFileRoute("/")({
	component: Index,
	validateSearch,
	loaderDeps: ({ search }) => ({
		s: search.s,
		origin: search.o,
		destination: search.d,
		locale: typeof search.locale === "string" ? normalizeLocale(search.locale) : undefined,
	}),
	loader: ({ deps }) => {
		if (!deps.s) {
			throw redirect({
				to: "/404",
				search: {
					locale: deps.locale,
				},
			});
		}
		const scheduledDateRaw = deps.s.slice(0, 4);
		const serviceName = deps.s.slice(4);

		const month = scheduledDateRaw.slice(0, 2);
		const day = scheduledDateRaw.slice(2, 4);
		const today = new Date();
		let year = today.getFullYear();

		// Handle end of year and beginning of year edge cases
		if (today.getMonth() === 0) {
			if (month === "12") {
				year = year - 1;
			}
		}

		if (today.getMonth() === 11) {
			if (month === "01") {
				year = year + 1;
			}
		}

		const scheduledDate = `${year}-${month}-${day}`;

		throw redirect({
			to: "/$scheduledDate/$serviceName",
			params: {
				serviceName,
				scheduledDate,
			},
			search: {
				o: deps.origin,
				d: deps.destination,
				locale: deps.locale,
			},
		});
	},
});
